export default "/fcbcac1db17390110677298f9d30eeed9c121039/062e30a7ac6b62636e98a277a6442dbf.svg";